import Marionette from 'backbone.marionette'
import contactsPlaceholderTemplate from 'text-loader!templates/settings/contacts/contactsPlaceholder.html'

var ContactsPlaceholderView = Marionette.ItemView.extend({
  template: contactsPlaceholderTemplate
});

export default ContactsPlaceholderView;

